import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { api } from "~/api/client";
import type { ChainMeta, AdapterMeta } from "~/api/types";

export function useChains() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["chains"],
    queryFn: () => api.getChains(),
    staleTime: 24 * 60 * 60 * 1000, // 24h
  });

  const chains: ChainMeta[] = data?.chains ?? [];
  const adapters: AdapterMeta[] = data?.adapters ?? [];

  const getChain = useCallback(
    (chainId: string): ChainMeta | undefined => chains.find((c) => c.chainId === chainId),
    [chains],
  );

  return { chains, adapters, getChain, isLoading, error };
}
